<template>
    <div class="gap-xs flex items-center">
        <slot>field name</slot>
        <button class="btn-link px-xs" @click="emitSortFunction">
            <div class="flex">
                <i
                    :class="{
                        'i-sorting-arrows': sortColumn !== fieldName,
                        'i-down-arrow': sortColumn === fieldName && !sortDirection,
                        'i-up-arrow': sortColumn === fieldName && sortDirection,
                    }"
                >
                </i>
            </div>
        </button>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    fieldName: String,
    sortColumn: String,
    sortDirection: Boolean,
});

const emit = defineEmits(['sort']);

function emitSortFunction() {
    emit('sort', props.fieldName);
}
</script>
